var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 988496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 987364"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2114",
    x: 7,
    y: 6,
    width: 12,
    height: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M24 12L21.3382 8.81143L21.7091 4.59429L17.7709 3.65714L15.7091 0L12 1.66857L8.29091 0L6.22909 3.64571L2.29091 4.57143L2.66182 8.8L0 12L2.66182 15.1886L2.29091 19.4171L6.22909 20.3543L8.29091 24L12 22.32L15.7091 23.9886L17.7709 20.3429L21.7091 19.4057L21.3382 15.1886L24 12Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75 8C8.785 8 8 8.785 8 9.75C8 10.715 8.785 11.5 9.75 11.5C10.715 11.5 11.5 10.715 11.5 9.75C11.5 8.785 10.715 8 9.75 8ZM9.75 10.5C9.335 10.5 9 10.165 9 9.75C9 9.335 9.335 9 9.75 9C10.165 9 10.5 9.335 10.5 9.75C10.5 10.165 10.165 10.5 9.75 10.5ZM14.25 12.5C13.285 12.5 12.5 13.285 12.5 14.25C12.5 15.215 13.285 16 14.25 16C15.215 16 16 15.215 16 14.25C16 13.285 15.215 12.5 14.25 12.5ZM14.25 15C13.835 15 13.5 14.665 13.5 14.25C13.5 13.835 13.835 13.5 14.25 13.5C14.665 13.5 15 13.835 15 14.25C15 14.665 14.665 15 14.25 15ZM8.705 16L8 15.295L15.295 8L16 8.705L8.705 16Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferblack);
export default __webpack_public_path__ + "static/media/offerblack.da6b4a452bbc57e2485698a1beb7c398.svg";
export { ForwardRef as ReactComponent };